import { DEVICE_CATEGORY, DEVICE_MARKER_COLOR } from '@/helpers/constants';
import React from 'react';

export default function DeviceMarker(props) {
  const { size, disabled, deviceinfo, noStroke } = props;
  const deviceCategory = deviceinfo?.deviceCategory ?? '';
  let color = '#dddddd';
  switch (deviceCategory) {
    case DEVICE_CATEGORY.MERAKI:
      color = DEVICE_MARKER_COLOR.MERAKI;
      break;
    case DEVICE_CATEGORY.VERKADA:
      color = DEVICE_MARKER_COLOR.VERKADA;
      break;
    case DEVICE_CATEGORY.BUTLR:
      color = DEVICE_MARKER_COLOR.BUTLR;
      break;
    case DEVICE_CATEGORY.WEBEX:
      color = DEVICE_MARKER_COLOR.WEBEX;
      break;
    case DEVICE_CATEGORY.ARUBA:
      color = DEVICE_MARKER_COLOR.ARUBA;
      break;
    default:
      break;
  }
  let iconSize = 36;
  if (size) {
    iconSize = size;
  }
  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={disabled ? '#A2A8BB' : color}
        stroke={noStroke ? 'none' : 'white'}
        d="M12 0.5C15.0447 0.5 17.7184 1.56216 20.042 3.70508C22.3367 5.82147 23.5 8.6676 23.5 12.2998C23.5 14.6661 22.5585 17.2878 20.6045 20.1758C18.7047 22.9837 15.8416 26.038 12 29.3398C8.15839 26.038 5.29533 22.9837 3.39551 20.1758C1.44154 17.2878 0.5 14.6661 0.5 12.2998C0.500042 8.6676 1.66326 5.82147 3.95801 3.70508C6.28156 1.56216 8.95527 0.5 12 0.5ZM12 8.5C11.0413 8.5 10.2079 8.84682 9.52734 9.52734C8.84682 10.2079 8.5 11.0413 8.5 12C8.5 12.9587 8.84682 13.7921 9.52734 14.4727C10.2079 15.1532 11.0413 15.5 12 15.5C12.9587 15.5 13.7921 15.1532 14.4727 14.4727C15.1532 13.7921 15.5 12.9587 15.5 12C15.5 11.0413 15.1532 10.2079 14.4727 9.52734C13.7921 8.84682 12.9587 8.5 12 8.5Z"
      ></path>
    </svg>
  );
}
